import { render, staticRenderFns } from "./drawer-stand-battery-status.vue?vue&type=template&id=8f73ed88&"
import script from "./drawer-stand-battery-status.vue?vue&type=script&lang=js&"
export * from "./drawer-stand-battery-status.vue?vue&type=script&lang=js&"
import style0 from "./drawer-stand-battery-status.vue?vue&type=style&index=0&id=8f73ed88&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports